module.exports = __webpack_public_path__ + "img/action-blue.52f7e69b.svg";